module.exports = __webpack_public_path__ + "static/media/planejarRotas.d323b9ed.svg";